import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const IterationCw: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M4 10c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8H4' }],
    ['polyline', { points: '8 22 4 18 8 14' }],
  ],
];

export default IterationCw;
